import {ScoresListWidgetController} from "../scores-list-widget.controller";
import {ScoresListWidgetState} from "../models/scores-list-widget.state";
import {HISTORY_ACTIONS} from "../../../core/consts";
import {PartialGameDataSource} from "../../../domain/partial-game/models/partial-game-data-source";
import {PartialGameDomainModel} from "../../../domain/partial-game/models/partial-game-domain-model";
import {BaseComponentLifecycleEventHandler} from "../../../infrastructure/handlers/base-component-lifecycle-event-handler";
import {GameCardViewModel} from "../../../core/components/game-card/view-models/game-card.view-model";

export class ScoresListWidgetStatePopulation extends BaseComponentLifecycleEventHandler {
  controller: ScoresListWidgetController;
  state: ScoresListWidgetState;

  async onLoaded() {
    super.onLoaded();

    const isBack: Boolean = !this.state.appState.settings.isWidget && this.historyManager.action === HISTORY_ACTIONS.pop;

    if (isBack) {
      this.state.gamesVM?.forEach((game: GameCardViewModel) => game.isLastVisitedGame = game.id === this.appStore.state.lastSelectedGameId);
    } else {
      this.appStore.state.showAllScores = this.state.appSettings.bootstrapSettings?.alwaysShowAllActiveCompetitions;
    }

    this.appStore.state.lastSelectedGameId = null;
  }

  onDataSourcePopulated(dataSource: PartialGameDataSource) {
    super.onDataSourcePopulated(dataSource);

    this.state.appState.liveGamesCount = this.state.liveGamesCount

    if (!this.appStore.state.showAllScores && dataSource && !dataSource.isDelta) {
      this.state.majorCompetitionsIds = dataSource.games.map((game: PartialGameDomainModel) => game.competition.id).distinct();
    }
  }
}
